/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { InitUserService } from './app/@theme/services/init-user.service';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import './polyfills';

export function init_app(initUserService: InitUserService) {
  return () =>
    new Promise<void>((resolve, reject) => {
      initUserService.initCurrentUser().subscribe({
        next: () => resolve(),
        error: (err) => reject(err)
      });
    });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
